import { useLang } from '@common/hooks/use-lang';
import { useMemo } from 'react';
import { BACKEND_URL } from '../../../../constants';

/**
 * Returns the URL of the legal PDF document based on the selected language.
 * If the backend URL is not available, an empty string is returned.
 */
export const useLegalPdfUrl = (): string => {
  const language = useLang();

  return useMemo(() => {
    if (!BACKEND_URL) {
      return '';
    }
    if (language === 'fr') {
      return BACKEND_URL.replace(
        /(v1\/)$/,
        'Politique-de-confidentialite-et-dutilisation.pdf'
      );
    } else if (language === 'it') {
      return BACKEND_URL.replace(
        /(v1\/)$/,
        'Protezione-dei-dati-e-condizioni-di-utilizzo.pdf'
      );
    } else {
      return BACKEND_URL.replace(/(v1\/)$/, 'Datenschutz_und_Nutzungsbestimmungen.pdf');
    }
  }, [language]);
};
